<script lang="ts">
  // One cell of the mockup's 4-up stat strip — label eyebrow, big DM Sans
  // number, optional unit suffix. Used standalone or inside StatRow.
  const {
    label,
    value,
    unit
  }: { label: string; value: string | number; unit?: string } = $props();
</script>

<div class="bg-surface px-4 py-3.5">
  <div class="text-[11px] font-semibold uppercase tracking-[.05em] text-dark-gray">{label}</div>
  <div class="mt-1 flex items-baseline gap-1.5">
    <span class="tym-stat-value text-[23px]">{value}</span>
    {#if unit}
      <span class="text-[11.5px] text-dark-gray">{unit}</span>
    {/if}
  </div>
</div>
